import { getSanityBunnyImageLink } from '@/utils/image'

export default {
  data: () => ({
    galleryWidth: 900,
  }),
  methods: {
    getImages(image, type, format) {
      return [
        {
          image: {
            url: getSanityBunnyImageLink(image, {
              width: 640,
              height: 800,
            }),
            dimensions: {
              width: 640,
              height: 800,
            },
          },
          widths: [375, 750],
          media: {
            type: 'max',
            value: 384,
          },
        },
        {
          image: {
            url: getSanityBunnyImageLink(image, {
              width: 640,
              height: 800,
            }),
            dimensions: {
              width: 640,
              height: 800,
            },
          },
          widths: [414, 828],
          media: {
            type: 'min-max',
            min: 385,
            max: 768,
          },
        },
        {
          image: {
            url: getSanityBunnyImageLink(
              image,
              format === 'landscape'
                ? {
                    width: 990,
                    height: 640,
                  }
                : {
                    width: 640,
                    height: 800,
                  }
            ),
            dimensions:
              format === 'landscape'
                ? {
                    width: 990,
                    height: 640,
                  }
                : {
                    width: 640,
                    height: 800,
                  },
          },
          widths:
            type === 'three-per-line'
              ? [330, 660, 990]
              : type === 'two-per-line'
              ? [500, 1000, 1500]
              : [1000, 1500, 2000],
          media: {
            type: 'min',
            value: 769,
          },
        },
      ]
    },
    calculateHeightOfLine(line, gap) {
      const w = this.galleryWidth - gap * (line.number - 1)
      return w / line.number / line.ratio
    },
    getGalleryGridTemplateRows(lines, gap, lineWithZoomElement = null) {
      return lines
        .map((numberOfItemsInLine, lineNumber) => {
          if (
            lineWithZoomElement !== null &&
            lineWithZoomElement === lineNumber
          ) {
            return `${this.calculateHeightOfLine(
              { ...numberOfItemsInLine, number: 1 },
              gap
            )}px`
          }
          return `${this.calculateHeightOfLine(numberOfItemsInLine, gap)}px`
        })
        .join(' ')
    },
  },
}
